import styled from "styled-components";

export const MainTourWrapper = styled.div`
        background: rgba(255, 255, 255, 0.60);
        position:fixed;
        top:0;
        left:0;
        right:0;
        bottom:0;
        z-index:999;
        display:flex;
        align-items:center;
        justify-content:center;

        @media(max-width:575px){
            overflow:auto;
            padding:15px;
            align-items:flex-start;
        }
`

export const Card= styled.div`
    width:50rem;
    min-height:50rem;
    background:#fff;
    border-radius:0.5rem;
    box-shadow: 0px 0px 50px 0px rgba(51, 164, 255, 0.50);
    overflow-hidden;
    display:flex;
    flex-direction:column;
    @media(max-width:575px){
        width:auto;
        max-width:100%;
    }
`;
export const CardImgDiv= styled.div`
     width:100%;
     height:22.8rem;
     display:flex;
     justify-content:center;
     position:relative;
     border-bottom:0.1rem solid #E0E0E0;
     overflow:hidden;
     @media(max-width:575px){
        height:150px;
    }
     &.card-1{
        align-items:flex-end;
        background:rgba(230, 230, 230,.1);
     }
     img{
        max-width:100%;
        @media(max-width:575px){
            height:100%;
        }
     }

`;

export const LeftText = styled.div`
    border-left:0.4rem solid #118ACB;
    position:absolute;
    top:2.4rem;
    left:0;
    padding:0.3rem 1.7rem;
    border-radius:0px 6px 6px 0px;
    background: #E8F4F6;
    width:28rem;
    color: #118ACB;
    font-size: 1.4rem;
    font-weight: 600;
`
export const CardBody = styled.div`
    padding:1.6rem 3rem;
    color: #4A4A4A;
    font-size: 1.4rem;
    line-height: 150%;
    font-weight: 400;
    flex:1;
    .counter-text{
        opacity:0.5;
        font-size:1.2rem;
        font-weight:600;
    }
    h2{
        font-size: 1.6rem;
        font-weight: 700;
        margin-bottom:0.8rem;
    }
    p{
        margin-bottom:0.8rem;
    }
`;

export const CardFooter = styled.div`
   display:flex;
   gap:1rem;
   align-items:center;
   justify-content:space-between;
   padding:1rem 3rem 2rem 3rem;
   @media(max-width:575px){
        flex-wrap:wrap;
        justify-content:center;
    }
   .left-footer{
     height:2rem;
     display:inline-flex;
     gap:0.5rem;
     align-items: center;
     button{
            display:inline-flex;
            height:0.8rem;
            width:0.8rem;
            border-radius:50%;
            background: #C4C4C4;
            padding:0;
            scale:0.5;
            transition:0.25s ease;
            &.active{
                    background:#3D90DD;
                    scale:1;
            }
        } 
        @media(max-width:575px){
           width:100%;
        }
   }
   .right-footer{
    .link-btn{
        display: inline-flex;
        align-items:center;
        color: #3D90DD;
        font-size:1.4rem;
        font-weight:500;
        letter-spacing: 0.046rem;
    }
    .blue-link-btn{
            background:#3D90DD;
            color:#fff;
            border-radius: 0.4rem;
            display: inline-flex;
            align-items:center;
            padding:0.5rem 2rem;
            min-height:3.5rem;
            margin-left:3rem;
            font-size:1.4rem;
            font-weight:500;
    }
    @media(max-width:575px){
        width:100%;
     }
}   
`;
export const FooterDiv = styled.div`
   position:fixed;
   bottom:0;
   left:0;
   right:0;
   height:5rem;
   padding:1.3rem 9.6rem;
   display:flex;
   align-items:center;
   flex-wrap:wrap;
   gap:1.2rem;
   justify-content:space-between;
   background:#3D90DD;

   .title_btn{
     background:rgba(13, 44, 84, .3);
     padding:0.3rem 1.4rem;
     font-size:1.4rem;
     color:#fff;
     font-weight: 700;
     border-radius: 0.5rem;
     pointer-events:none;
   }
   .exit-link{
    display:flex;
    border-bottom:0.1rem solid #fff;
    color:#fff;
    font-size: 1.4rem;
    font-weight: 700;
    line-height:120%;
   }

   @media(max-width:575px){
      display:none;
   }
`;